import Sso from './Sso'

export default Sso
